var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrs-header"},[_c('div',{staticClass:"nrs-container"},[_c('div',{staticClass:"nrs-header__logo"},[_c('img',{attrs:{"src":require("../assets/nrs-logo@2x.png"),"onclick":"location.href='https://www.netroadshow.com'"}})])])])
}]

export { render, staticRenderFns }